module.exports = __webpack_public_path__ + "static/media/advantages_bar_middle.3350fd62.svg";